import { Alert, Button, CircularProgress, Stack } from '@mui/material';
import React from 'react';
import { useContactCaptureRecordController } from '../../controllers';

type Props = { controller: ReturnType<typeof useContactCaptureRecordController> };

export const ContactCaptureLoadingState = ({ controller }: Props) => {
  if (controller.loading) {
    return (
      <Stack alignItems="center" justifyContent="center" height="100%">
        <CircularProgress aria-label="Loading contact capture" />
      </Stack>
    );
  }

  if (controller.error) {
    return (
      <Alert
        severity="error"
        action={<Button color="inherit" onClick={() => void controller.retry()}>Retry</Button>}
      >
        {controller.error}
      </Alert>
    );
  }

  return null;
};
